import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../../components/shared/Loader";
import userPlaceholder from "../../../assets/images/placeholder.jpg";
import { updateMeta } from "../../../store/actions/metaAction";

const BenefitsHeaderCreate = () => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const [titleEn, setTitleEn] = useState("");
	const [descriptionEn, setDescriptionEn] = useState("");
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "اضافة مقدمه جديد",
				breadcrumb: "المقدمه",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
	};

	const handleSubmit = e => {
		e.preventDefault();

		if (!title || !titleEn || !description || !descriptionEn) {
			return toast.error("جميع البيانات مطلوبة");
		}

		const data = {
			title: {
				ar: title,
				en: titleEn,
			},
			description: {
				ar: description,
				en: descriptionEn,
			},
		};
		axios
			.post(
				`${process.env.REACT_APP_API_URL}/posts`,
				{
					admin_id: auth.id,
					category_id: 30,
					data: data,
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				history.push("/benefits/benefitsHeader/index");
				toast.success("تم اضافة المقدمه بنجاح!");
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-12">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="title">العنوان</label>
									<input
										type="text"
										id="title"
										onChange={e => setTitle(e.target.value)}
									/>
								</div>

								<div className="form-item">
									<label htmlFor="description">الوصف</label>
									<textarea
										id="description"
										cols="30"
										rows="2"
										onChange={e => setDescription(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="title"> العنوان بالانجليزيه </label>
									<input
										type="text"
										id="title" dir="ltr"
										onChange={e => setTitleEn(e.target.value)}
									/>
								</div>

								<div className="form-item">
									<label htmlFor="description"> الوصف بالانجليزيه</label>
									<textarea
										id="description"
										cols="30" dir="ltr"
										rows="2"
										onChange={e => setDescriptionEn(e.target.value)}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-12">
						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default BenefitsHeaderCreate;
